import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;

  height: 81px;

  margin: 20px 30px 0px;
  padding: 20px 32px;

  background: ${colors.white};
  border-radius: 4px;

  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
`

export const ContainerTextCalendar = styled.div`
  display: flex;
  flex-direction: column;
`

export const ContainerCalendar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ContainerFilter = styled.div`
  display: flex;
  flex: 1;

  align-items: center;

  max-width: 400px;
`

export const Label = styled.span`
  font-size: 12px;
  color: ${colors.blue};
`
export const ContainerExportarExtratoPdf = styled.div`
  display: none;
`
export const ContainerButton = styled.div`
  display: flex;
`
